import React, {useEffect, useState} from "react";
import {alpha, Box} from "@mui/material";
import _ from 'lodash'
import {bucketUrl} from "../../configuration";
import {customTheme} from "../../theme/customTheme";
import {useSearchParams} from "react-router-dom";

export const FotoWallContent = ({g, rows, columns}) => {
    const [searchParams] = useSearchParams({});

    const picPadding = 2
    const [grid, setGrid] = useState([])
    useEffect(() => {
        setGrid(g)
    },[g])

  return(
      <Box pl={picPadding} pt={picPadding} id={'gallery'}
           style={{gridTemplateColumns: 'repeat(' + columns + ', 1fr)', gridTemplateRows: 'repeat(' + rows + ', 1fr)',
               width: `${searchParams.get('w') || 1920}px`,
               height: `${searchParams.get('h') || 1080}px`,
      }}>
          {
              _.slice(grid, 0, grid.length - (grid.length % (rows*columns))).map((image, i) => {
                  return (<Box mr={picPadding} mb={picPadding} key={i} style={{
                      backgroundPosition:'center',
                      backgroundImage: `url(${bucketUrl}/${image.filename})`,
                      borderRadius: '1rem',
                      border: `4px solid ${alpha(customTheme.palette.secondary.main, 1)}`
                  }}>
                  </Box>)
              })
          }
      </Box>
  )
}
